module.exports = __webpack_public_path__ + "static/img/华为红枫影像技术.ae22f5c3.png";